import Tooltip from "../../../../../components/Tooltip";
import Icon from "../../../../../../components/Icon";
import InfoIcon from '../../../../../../assets/icons/info.svg'
import { Pill } from "./styles";

const states = {
  active: {
    label: "Activo",
    color: {
      text: "#12B47A",
      background: "#DCF4EB",
    },
  },
  non_renewing: {
    label: "Vencimiento próximo",
    color: {
      text: "#EB5757",
      background: "#FCE6E6",
    },
    tooltip:
      "El suscriptor canceló su suscripción, pero mantendrá acceso hasta que finalice el período pagado.",
  },
  defaulted: {
    label: "Cancelado",
    color: {
      text: "#303030",
      background: "#F2F2F7",
    },
  },
  cancelled: {
    label: "Cancelado",
    color: {
      text: "#303030",
      background: "#F2F2F7",
    },
  },
  paid: {
    label: "Activo",
    color: {
      text: "#12B47A",
      background: "#DCF4EB",
    },
  },
  refunded: {
    label: "Reembolsado",
    color: {
      text: "#975102",
      background: "#FAF0D2",
    },
  },
  paused: {
    label: "Pausada",
    color: {
      text: "#975102",
      background: "#FAF0D2",
    },
  },
  pending_invite: {
    label: "Invitado pendiente",
    color: {
      text: "#975102",
      background: "#FAF0D2",
    },
  },
  expired: {
    label: "Cancelado",
    color: {
      text: "#303030",
      background: "#F2F2F7",
    },
  },
  in_trial: {
    label: "Periodo de prueba",
    color: {
      text: "#975102",
      background: "#FAF0D2",
    },
  },
  not_paid: {
    label: "Problema con el pago",
    color: {
      text: "#EB5757",
      background: "#FCE6E6",
    },
    tooltip:
      "No pudimos realizar el cobro. No es necesario que hagas nada por ahora. Le solicitamos por whataspp que reintente el pago.",
  },
  void: {
    label: "Anulada",
    color: {
      text: "#2C3E50",
      background: "#D6E4F0",
    },
    tooltip:
      "Como no pudimos realizar el primer cobro o no se pudo completar el pago, la suscripción fue anulada.",
  },
  completed: {
    label: "Completada",
    color: {
      text: "#4F4F4F",
      background: "#E0E0E0",
    },
    tooltip:
      "La suscripción se completó y el suscriptor ya no tiene más acceso al contenido.",
  },
  renewal_retrying: {
    label: "Reintentando pago",
    color: {
      text: "#EB5757",
      background: "#FCE6E6",
    },
    tooltip:
      "No pudimos renovar la suscripción. No es necesario que hagas nada por ahora. Le solicitamos que actualice su método de pago y haremos reintentos en los proximos 10 dias",
  },
  retrying: {
    label: "Re-procesando",
    color: {
      text: "#EB5757",
      background: "#FCE6E6",
    },
    tooltip:
      "El suscriptor ya actualizó su método de pago y estamos reintentando iniciar la suscripción. No es necesario que hagas nada por ahora.",
  },
  waiting_for_gateway: {
    label: "Verificando pago",
    color: {
      text: "#0066CC",
      background: "#E3F2FD",
    },
    tooltip:
      "Por políticas de Mercado Pago este proceso puede tardar algunas horas.",
  },
  // Additional verification states
  verifying_payment: {
    label: "Verificando pago",
    color: {
      text: "#0066CC",
      background: "#E3F2FD",
    },
    tooltip:
      "Por políticas de Mercado Pago este proceso puede tardar algunas horas.",
  },
  payment_pending: {
    label: "Pago pendiente",
    color: {
      text: "#0066CC",
      background: "#E3F2FD",
    },
    tooltip:
      "El pago está siendo procesado. Este proceso puede tardar algunas horas.",
  },
};


const Component = ({ subscriptionState, toolTipPositin }) => {
  const state = states[subscriptionState];

  // Fallback for unknown states
  const defaultState = {
    label: subscriptionState || "Desconocido",
    color: {
      text: "#333",
      background: "#f0f0f0",
    },
  };

  const currentState = state || defaultState;

  return (
    <>
      <Tooltip 
        enableTooltip={!!currentState?.tooltip} 
        content={currentState?.tooltip} 
        position={toolTipPositin}
      >
        <Pill styles={currentState?.color}>
          <div style={{ flexShrink: 0 }}>{currentState?.label}</div>
          {!!currentState?.tooltip && (
            <Icon 
              icon={InfoIcon} 
              size="14px" 
              color={currentState?.color?.text || "#666"} 
            />
          )}
        </Pill>
      </Tooltip>
    </>
  );
};

export default Component;